/**
 * Accordions
 *
 * WCAG-compliant accordion with smooth slide transitions.
 * Respects prefers-reduced-motion.
 */

const prefersReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const togglePanel = (trigger, panel) => {
  const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
  const willOpen = !isExpanded;

  trigger.setAttribute('aria-expanded', String(willOpen));

  if (prefersReducedMotion()) {
    panel.hidden = !willOpen;
    return;
  }

  // Clean up any in-progress animation
  if (panel._accordionCleanup) {
    panel.removeEventListener('transitionend', panel._accordionCleanup);
    panel._accordionCleanup = null;
  }

  if (willOpen) {
    panel.hidden = false;
    panel.removeAttribute('aria-hidden');
    const targetHeight = panel.scrollHeight;
    panel.style.overflow = 'hidden';
    panel.style.height = '0px';
    void panel.offsetHeight; // force reflow
    panel.style.height = targetHeight + 'px';

    panel._accordionCleanup = (e) => {
      if (e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', panel._accordionCleanup);
      panel._accordionCleanup = null;
      panel.style.height = '';
      panel.style.overflow = '';
    };
    panel.addEventListener('transitionend', panel._accordionCleanup);
  } else {
    panel.setAttribute('aria-hidden', 'true');
    panel.style.overflow = 'hidden';
    panel.style.height = panel.scrollHeight + 'px';
    void panel.offsetHeight; // force reflow
    panel.style.height = '0px';

    panel._accordionCleanup = (e) => {
      if (e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', panel._accordionCleanup);
      panel._accordionCleanup = null;
      panel.hidden = true;
      panel.removeAttribute('aria-hidden');
      panel.style.height = '';
      panel.style.overflow = '';
    };
    panel.addEventListener('transitionend', panel._accordionCleanup);
  }
};

const initAccordions = () => {
  const lists = document.querySelectorAll('.accordions__list');
  if (!lists.length) return;

  lists.forEach((list) => {
    const triggers = list.querySelectorAll('.accordion-item__trigger');

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const panelId = trigger.getAttribute('aria-controls');
        const panel = document.getElementById(panelId);
        if (!panel) return;
        togglePanel(trigger, panel);
      });
    });
  });
};

document.addEventListener('DOMContentLoaded', initAccordions);
